
/** 牌型数据区间 */
const CardTypeArea = [
    
]
export class GoldFlowerDataManage {

   
}